import {
  AppDispatch,
  deleteUser,
  deleteUserClear,
  deleteUserRequest,
  getUserRoleListRequest,
  useDynamicSelector } from
"@src/redux";
import { Button, Modal, notification } from "antd";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

interface RoleDeleteModalProps {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  profile: {
    role: string;
    name: string;
    id: string;
    systemUser: any;
  };
}

const RoleDeleteModal: React.FC<RoleDeleteModalProps> = ({
  modalOpen,
  setModalOpen,
  profile
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { filter: roleFilter } = useDynamicSelector("role_filter");
  const { pagination: rolePagination } = useDynamicSelector("role_pagination");

  const { result: deleteUserResult, loading: deleteUserLoading } =
  useSelector(deleteUser);

  useEffect(() => {
    if (modalOpen && deleteUserResult?.status === "success") {
      dispatch(deleteUserClear());
      toast.success(t("delete_role_success"));

      handleCancel();
      dispatch(
        getUserRoleListRequest({
          filter: { ...(roleFilter || {}) },
          pagination: rolePagination || { pageLimit: 10, pageNumber: 1 },
          sort: [{ field: "name", order: "asc" }]
        })
      );
    }
  }, [deleteUserResult?.status, modalOpen]);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleDelete = () => {
    dispatch(
      deleteUserRequest({
        id: profile?.id || ""
      })
    );
  };
  return (
    <Modal
      title={
      <span
        style={{ fontFamily: "Abel", fontSize: "20px" }}>
        {`Delete ${profile?.systemUser?.roleList?.[0]?.name}`}</span>}

      open={modalOpen}
      onCancel={handleCancel}
      footer={[
      <Button key="cancel" onClick={handleCancel}>
          {t("close")}
        </Button>,
      <Button
        key="delete"
        className="delete-role-button"
        onClick={handleDelete}
        loading={deleteUserLoading}>
        
          {t("delete")}
        </Button>]}

      destroyOnClose={true}>
      
      <span className="delete_message">
        {`Are you sure you want to delete the ${profile?.systemUser?.roleList?.[0]?.name} "${profile.name}" ?`}
      </span>
    </Modal>);

};

export default RoleDeleteModal;